import React from "react";
import { Tag } from "antd";
import { useIntl } from "react-intl";

const ReportLevel = (props) => {
  const { record } = props;
  const intl = useIntl();
  return (
    <div>
      {record && record.show_in_branch ? (
        <Tag color="cyan">
          {intl.formatMessage({
            id: "app.reports.branchLevel",
          })}
        </Tag>
      ) : (
        <Tag color="purple">
          {intl.formatMessage({
            id: "app.reports.organizationLevel",
          })}
        </Tag>
      )}
    </div>
  );
};

export default ReportLevel;
